var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 9,
    viewBox: "0 0 28 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2378 0C16.2498 0 14.4718 1.02222 14.4718 2.91111C14.4718 5.07778 17.6232 5.22639 17.6232 6.31389C17.6232 6.77222 17.094 7.18333 16.191 7.18333C15.4072 7.17824 14.6368 6.9812 13.9482 6.60972L13.538 8.51528C13.538 8.51528 14.644 9 16.1098 9C18.2826 9 19.9934 7.92778 19.9934 6.00694C19.9934 3.71806 16.8294 3.57222 16.8294 2.5625C16.8294 2.20278 17.2634 1.80972 18.165 1.80972C19.1828 1.80972 20.013 2.22639 20.013 2.22639L20.4134 0.386111C20.4134 0.386111 19.5104 0 18.2378 0ZM0.0475999 0.138888L0 0.416667C0 0.416667 0.8358 0.569444 1.5904 0.870833C2.5592 1.21806 2.6292 1.42083 2.7916 2.04861L4.5724 8.85695H6.958L10.6344 0.138888H8.2544L5.8912 6.06667L4.928 1.04167C4.8398 0.466667 4.3918 0.138888 3.843 0.138888H0.0475999ZM11.592 0.138888L9.7244 8.85695H11.9952L13.8558 0.138888H11.592ZM24.2536 0.138888C23.7076 0.138888 23.4164 0.430556 23.2036 0.9375L19.8772 8.85695H22.2572L22.7192 7.5375H25.6186L25.8986 8.85695H28L26.1674 0.138888H24.2536ZM24.563 2.49444L25.2686 5.76528H23.38L24.563 2.49444Z",
    fill: "#1E40AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.bc03dc705c2d736adf47b4fc1ec8e185.svg";
export { ForwardRef as ReactComponent };